import { useGetCities } from "hooks/useRequest/location/location";
import { FC, useMemo } from "react";
import DropDown, { IDropDownTypes } from "..";



interface IProps extends IDropDownTypes {
    city?: string
    enabled?: boolean
    onChangeObject?: (value: any) => void
    province?: string
}


const CityDropdown: FC<IProps> = ({ province, onChangeObject, enabled, ...props }) => {

    const { data, isLoading } = useGetCities({
        enabled: enabled ?? true,
        params: {
            province: province
        }
    })

    const changeHandler = (value: string | string[]) => {
        props.onChange?.(value);

        onChangeObject &&
            onChangeObject(
                props.isMulti && Array.isArray(value)
                    ? data?.data?.filter(res => value.includes(res._id))
                    : data?.data?.find(res => res._id === value),
            );
    };

    const list = useMemo(
        () =>
            data?.data?.map(res => {
                return {
                    value: res._id,
                    label: res.name,
                };
            }) ?? [],
        [data],
    );

    return (
        <DropDown
            data={list}
            loading={isLoading}
            {...props}
            onChange={value => changeHandler(value)}
        />
    );
}

export default CityDropdown